module.exports = __webpack_public_path__ + "img/risks-relationship-issues.c289dc3c.svg";